<div class="row">
    <div class="col-xs-12 col-sm-9">
        <mat-card class="my-4">
            <ng-container *ngIf="isPricelistGrid ; else showProductEdit">
                <div class="item-grid-container search-holder">
                    <ul class="list-inline grid-top-actions mb-3">
                        <li class="list-inline-item ">
                            <input type="text" placeholder="{{ 'pages.newRetailer.search' | translate }}" matInput
                                class="
                          rounded-pill
                          px-3
                          py-2
                          mb-0
                          border-0
                          bg-light
                          w-100
                          me-0
                          input-search
                          ms-3
                        " (keyup)="quickSearch()" [(ngModel)]="searchValue" />
                            <i color="primary" class="search-icon-holder" matSuffix mat-icon-button aria-label="Search">
                                <mat-icon>search</mat-icon>
                            </i>
                        </li>
                        <li class="list-inline-item float-end">
                            <button mat-stroked-button class="bg-theme" (click)="exportData()">
                                <span translate class="translate">pages.newRetailer.download</span>
                                <i class="mi mi-save-alt"></i>
                            </button>
                        </li>

                        <li class="list-inline-item float-end me-2">
                            <button mat-stroked-button [disabled]="!showSelectedPricelist" class="bg-theme"
                                (click)="editPricelist()">
                                {{ "pages.newRetailer.edit" | translate }}
                                <i class="mi mi-drive-file-rename-outline"></i>
                            </button>
                        </li>
                    </ul>
                    <div class="report-grid">
                        <ag-grid-angular style="width: 100%; height: 65vh" class="ag-theme-material" [rowHeight]="40"
                            [enableFilter]="true" [enableSorting]="true" [enableColResize]="true"
                            [rowSelection]="rowSelection" [rowData]="rowData" [columnDefs]="columnDefs"
                            (gridReady)="onGridReady($event)" (selectionChanged)="onSelectionChanged($event)">
                        </ag-grid-angular>
                    </div>
                </div>
            </ng-container>

            <ng-template #showProductEdit>
                <form [formGroup]="updatePricelistForm" (ngSubmit)="onSubmitUpdatePricelist()">
                    <h5 class="content-label-each" translate>
                        Update Pricelist
                    </h5>
                    <div class="form-inner content-details-blk">
                        <div class="row">
                            <div class="col-sm-3 col-xs-12 align-self-center">
                                <h4 class="form-item-label">Pricelist name (Current)</h4>
                            </div>
                            <div class="col-sm-5 col-xs-12">
                                <div class="form-item-input">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <input matInput required [formControl]="initialName" readonly />
                                    </mat-form-field>
                        
                                </div>
                            </div>
                        </div>
                        <div class="row  my-4">
                            <div class="col-sm-3 col-xs-12 align-self-center">
                                <h4 class="form-item-label">Pricelist name (New)</h4>
                            </div>
                            <div class="col-sm-5 col-xs-12">
                                <div class="form-item-input">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <input matInput required formControlName="priceListName"
                                            placeholder="Enter pricelist name" />
                                        <mat-error *ngIf="f.priceListName?.errors?.required && f.priceListName?.touched" class="text-danger ms-2">
                                            pricelist name is required</mat-error>
                                    </mat-form-field>

                                </div>
                            </div>
                        </div>
                        <div class="row my-4">
                            <div class="col-sm-3 col-xs-12 align-self-center">
                                <h4 class="form-item-label">Pricelist status</h4>
                            </div>
                            <div class="col-sm-5 col-xs-12">
                                <div class="form-item-input">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-select formControlName="priceListStatus" placeholder="pricelist status">
                                            <mat-option value="Active">Active</mat-option>
                                            <mat-option value="InActive">InActive</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="f.priceListStatus?.errors?.required && f.priceListStatus?.touched"
                                            class="text-danger ms-2">
                                            pricelist status is required</mat-error>
                                    </mat-form-field>
                        
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3 col-xs-12 align-self-cewhnter">
                                <h4 class="form-item-label">Pricelist Type</h4>
                            </div>
                            <div class="col-sm-5 col-xs-12">
                                <div class="form-item-input">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <input matInput required readonly formControlName="priceListType" placeholder="Pricelist Type" />
                                        <mat-error *ngIf="f.priceListType?.errors?.required && f.priceListType?.touched"
                                            class="text-danger ms-2">
                                            pricelist type is required</mat-error>
                                    </mat-form-field>
                        
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-footer mt-3 text-center me-lg-3">
                        <button mat-raised-button type="button" class="mx-3" (click)="isPricelistGrid = true">Cancel</button>
                        <button mat-raised-button color="primary" type="submit" [disabled]="updatePricelistForm.invalid">Save</button>
                    </div>
                </form>
            </ng-template>
        </mat-card>
    </div>
</div>